import { render, staticRenderFns } from "./GainOnSaleDetail.vue?vue&type=template&id=bd5994fc&"
import script from "./GainOnSaleDetail.vue?vue&type=script&lang=js&"
export * from "./GainOnSaleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports